import builder from '../builder';
import AccountingCoinsStack from '../../streamline-icons/bold/accounting-coins-stack.svg';

export default builder('IconAccountingCoinsStackBold', AccountingCoinsStack);
